import Loadable from "react-loadable";
import Loader from "components/shared/loader/loader";
import { IRoute } from "shared/interface/types";
const parentBreadCrumbs = [{ title: "menu_sidebar_service_provider", link: "/service-provider" }];

const ServiceProvider = Loadable({
  loader: () => import("../../container/serviceProvider"),
  loading() {
    return <Loader />;
  }
});
const ServiceProviderListing = Loadable({
  loader: () => import("../../container/serviceProvider/listing"),
  loading() {
    return <Loader />;
  }
});

export const ServiceProviderRoutes: IRoute[] = [
  {
    path: "/service-provider/details/:id?",
    element: <ServiceProvider />,
    handle: {
      crumbs: [...parentBreadCrumbs]
    }
  },
  {
    path: "/service-provider",
    element: <ServiceProviderListing />,
    handle: {
      crumbs: parentBreadCrumbs
    }
  }
];
